import React, {createContext, useState, useContext} from "react"
import axios from "axios"

const newApiRoot = "https://api.marineblue-g.com"


// castDataProviderから移設. 一旦写メ日記取得とキャストのヘブン側IDの状態管理のみ実装.
// 暇があればキャストデータの通信関数もこちらにすべて纏めます (=関心の分離).

const CastDataContext = createContext()
export const useCastData =()=>useContext(CastDataContext)

export default function CastDataProvider({children}){

    const [hvnId, setHvnId]=useState(null)
    const [castDiaryData, setCastDiaryData] = useState([])


    const getCastDiary =(hvnDiaryUrl)=>{
        
        axios({
            method: "get",
            url: `${newApiRoot}/v2/diary_cast?t=` + hvnDiaryUrl
        })
        .then((res=>{
            // console.log(res)
            setCastDiaryData(res.data)
        }))
    }


    const updateHvnId=(id)=>{
        setHvnId(id)
        return null
    }

    const resetHvnId=()=>{
        setHvnId(null)
        return null
    }


    return(
        <CastDataContext.Provider value={{
            hvnId,
            updateHvnId, resetHvnId,  
            castDiaryData, getCastDiary
        }}>
            {children}
        </CastDataContext.Provider>
    )
}